import { DeliveryMethodType } from 'src/consts';

export const getSegmentOrderStatus = (orderStatus: string, deliveryMethodKey: DeliveryMethodType) => {
  switch (deliveryMethodKey) {
    case DeliveryMethodType.courier:
      return orderStatus;
    case DeliveryMethodType.mail:
      return 'shipped';
    case DeliveryMethodType.pickupStation:
      return 'Delivered Health Clinic';
    default:
      return orderStatus;
  }
};
